import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { useViewport } from 'components/hooks'

import styles from './styles.module.scss'

const RateTableAprValue = ({
  minRate,
  maxRate,
  withBottomBorder = false,
  isVariable = false,
  className,
}) => {
  const { xSmall } = useViewport()

  const title = `${isVariable ? 'Variable' : 'Fixed'} APR from`

  return xSmall ? (
    <div
      className={cx('pure-u-1 pure-u-md-1-4 pure-u-sm-1-3', styles.row, className, {
        [styles.withBottomBorder]: withBottomBorder,
      })}
    >
      <p className={cx(styles.FixAPRtitle, 'bodySmall neutral500')}>{title}</p>
      <p className={cx(styles.FixAPRvalue, 'semiBold heading')}>
        {minRate}%
        <br />
        <p className="bodySmall neutral500">to {maxRate}%</p>
      </p>
    </div>
  ) : (
    <div className={cx('pure-u-1 pure-u-md-1-4 pure-u-sm-1-3', className)}>
      <p className="bodySmall neutral500">{title}</p>
      <p className="bodyLarge semiBold">
        {minRate}% - {maxRate}%
      </p>
    </div>
  )
}

RateTableAprValue.propTypes = {
  minRate: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]),
  maxRate: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]),
  withBottomBorder: PropTypes.bool,
  isVariable: PropTypes.bool,
  className: PropTypes.string,
}

export default RateTableAprValue
